export enum Actions {
    PROJECT_CREATION = 'project_create',
    PROJECT_DETAIL_VIEW= 'project_detail_view',
    DELETE= 'Delete',
    PROJECT= 'project',
    APPLICATIONS = 'applications',
    APPLICATION = 'application',
    PAGES = 'pages',
    APPLICATION_CREATE = 'application_create',
    APPLICATION_EDIT = 'application_edit',
    PAGE_CREATE = 'page_create',
    PAGE_EDIT = 'page_edit',
    PAGE_DELETE = 'page_delete',
    UI_OBJECT_CREATE = 'ui_object_create',
    UI_OBJECT_DELETE = 'ui_object_delete',
    APPLICATION_DELETE = 'application_delete',
    EDIT = 'Edit',
    EDIT_PROJECT = 'Edit_Project',
    SCRIPT_GROUP = 'script_group',
    TEST_SCRIPT_CREATE = 'test_script_create',
    TEST_SCRIPT_EDIT = 'test_script_edit',
    REUSABLE_COMPONENT = 'reusable_component',
    TEST_SCRIPT_GROUP = 'test_script_group',
    SCRIPT_GROUP_EDIT = 'script_group_edit',
    SCRIPT = 'SCRIPT',
    REUSABLE_SCRIPT_CREATE = 'reusable_script_create',
    REUSABLE_SCRIPT = 'REUSABLE_SCRIPT',
    REUSABLE_SCRIPT_FILE= 'reusable_script_file',
    REUSABLE_SCRIPT_EDIT= 'reusable_script_edit',
    REUSABLE_COMPONENT_FOLDER = 'reusable_component_folder',
    REUSABLE_COMPONENT_FOLDER_EDIT = 'reusable_component_folder_edit',
    API_SERVICE = "api-service",
    API_SERVICES = "api-services",
    API_SERVICE_VIEW = "api-service-view",
    OPERATION_VIEW = "operations"
  }